import React from 'react';
import { Link } from 'react-router-dom';
import { useDonationsEmptyStateRecommendations } from '@modules/Dashboard/modules/Recommendations/hooks/useDonationsEmptyStateRecommendations';
import { routing } from '@utils/routing';
import * as EmptyState from '../../../../components/EmptyState/EmptyState';
export const DonationsEmptyState = () => {
    const { recommendations } = useDonationsEmptyStateRecommendations();
    return (React.createElement(EmptyState.Root, { title: "You haven\u2019t received any standalone donations yet", subtitle: React.createElement(React.Fragment, null,
            "Orders with an added donation are in the",
            ' ',
            React.createElement(Link, { to: routing.contributions.orders.all }, "orders\u00A0tab"),
            ".") }, recommendations && recommendations.length > 0 && (React.createElement(EmptyState.Recommendations, null, recommendations.map(({ suggestion, id }) => {
        return (React.createElement(EmptyState.Suggestion, { key: `recommendation-${id}`, "data-analytics": id }, suggestion));
    })))));
};
